import React from 'react';
import { styles } from './ContentCard.css';
import { Base, LoadingSkeletonProps } from '../../Base/Base';
import { BaseContentCard } from '../../../ContentCard';
import { TextBlock } from '../TextBlock/TextBlock';
import { Box } from '../Box/Box';

type ContentCardSkeletonProps = { isContained?: boolean } & LoadingSkeletonProps;

export const ContentCard = ({ shouldShimmer = false, isContained = true, ...baseProps }: ContentCardSkeletonProps) => {
  return (
    <Base {...baseProps} className={styles.container}>
      <BaseContentCard
        isContained={isContained}
        cover={<Box backgroundColor="#f0f0f0" shouldShimmer={shouldShimmer} />}
      >
        <TextBlock
          lines={[
            { width: '225px', height: '18px', shouldShimmer, backgroundColor: '#f0f0f0' },
            { width: '250px', shouldShimmer, backgroundColor: '#f0f0f0' },
          ]}
        />
      </BaseContentCard>
    </Base>
  );
};
